
export const events = [
    {
        "id": "1",
        "name": "Przestań tracić czas na ręczne reklamy – AI to przyszłość!",
        "date": "11.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Czy nadal klikasz 'Promuj post' albo żonglujesz Ads Managerem, zamiast zająć się klientami? Dowiedz się, jak automatyzacja obniża koszty, sprawdź kalkulator oszczędności, poznaj skuteczne targetowanie i budowanie lejka sprzedażowego TOFU-MOFU-BOFU. Odkryj tajemnicę strategii 421 – Twój przepis na sukces! Case study: salony piękności, kosmetologia, paznokcie.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/4.png"
    },
    {
        "id": "2",
        "name": "Pisanie postów to już przeszłość – AI pisze za Ciebie!",
        "date": "12.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "CHAT GTP, Cloud, Gemini, LLAMA 3 – które narzędzie AI jest dla Ciebie? Naucz się schematów generujących treści w kilka sekund. Najlepsze narzędzia? Są dostępne w FastTony AI i to bez dopłat. Czas na rekord: 30 postów w mniej niż minutę!",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/5.png"
    },
    {
        "id": "3",
        "name": "Człowiek vs. Maszyna – kto lepiej tworzy reklamy na Facebooku?",
        "date": "13.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Promuj post, reklama w Ads Manager czy FastTony AI? Co działa lepiej? Co wymaga mniejszego wysiłku? Zobacz dlaczego marketerzy i agencje reklamowe przestały robić reklamy przez Ads Manager i wykorzystują do tego FastTony AI. Sprawdź sam, co jest lepsze dla Twojego biznesu. Case study: przykłady klientów FastTony.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/6.png"
    },
    {
        "id": "4",
        "name": "Jak zwiększyć ilość klientów, korzystając z pomocy AI?",
        "date": "14.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Poznaj sprawdzone sposoby wykorzystania sztucznej inteligencji w skutecznym pozyskiwaniu klientów online. Agenda: 1. Dlaczego reklamy to świetny sposób na pozyskanie klientów? 2. Jak AI może pomóc w pozyskiwaniu klientów? 3. Jak stworzyć reklamy za pomocą AI. 4. Automatyzacja procesów obsługi klienta zainteresowanego ofertą 5. Jak zablokować wystawianie negatywnych opinii i zdobywać tylko 5 gwiazdek. 6. Jak automatyzacja pozyskiwania i obsługi klientów pozwoli ci zarobić 30% więcej w 2025 roku.",
        "link": "https://akademia.fasttony.com/w/internet",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/7.png"
    },
    {
        "id": "5",
        "name": "Jak sprzedawać kursy ONLINE korzystając z pomocy AI?",
        "date": "15.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Poznaj sprawdzone sposoby wykorzystania AI w skutecznej sprzedaży kursów online. Dowiesz się: 1. Dlaczego reklamy to świetny sposób na sprzedaż kursów? 2. Jak AI może pomóc w pozyskiwaniu klientów? 3. Tworzenie reklam za pomocą AI Jak AI samo tworzy reklamy i targetuje w nich właściwe osoby optymalizując koszty 4. Jak Integracja z Web To Learn pomoże ci zautomatyzować pozyskiwanie klientów? 5. Jak zastosowanie TOFU, BOFU i MOFU buduje ci sprzedaż? 6. Dla Wszystkich którzy dotrwają do końca prezent Kurs Budowania Marki osobistej za Darmo",
        "link": "https://akademia.fasttony.com/w/kursy",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/8.png"
    },
    {
        "id": "6",
        "name": "Google Ads i Forsant.io – prosta konfiguracja, większe zyski",
        "date": "16.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Skonfigutowanie konta i reklam w Google ads w mniej niż 10 minut? TAK! Dzięki Forsant konfiguracja i późniejsza optymalizacja nie musi być skomplikowana. Zobacz, jak łatwo to zrobić z Forsant.IO, porównując z klasycznym Google Ads. Plus: instruktaż wideo krok po kroku!",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/9.png"
    },
    {
        "id": "7",
        "name": "Jak zdobywać pozycjonujące komentarze w Google za darmo.",
        "date": "17.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Dowiedz się, jak blokować negatywne komentarze od sfrustrowanych klientów i zbierać tylko pozytywne opinie. Zobacz, jak AI pomaga zwiększyć skuteczność w utrzymaniu klienta oraz tworzyć automatycznie reklamy do osób, które dzwoniły do Twojej firmy oraz do ich znajomych i poszukujących podobnych usług.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/Naglowek-3000-x-2000-px-6000-x-4000-px-700-x-467-px-3.png"
    },
    {
        "id": "8",
        "name": "Sztuka przyciągania – uwodzenie klientów za pomocą AI",
        "date": "18.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Czy wiesz, czego naprawdę pragną Twoi klienci? Z AI możesz wzbudzać zainteresowanie, motywować do działania i sprawić, by nikt się nie wycofał. Daj się przekonać, że zdobywanie klientów może być prostsze niż myślisz dzięki AI! W trakcie tego materiału dowiesz się co mówić aby nigdy ci nie odmawiano.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/11.png"
    },
    {
        "id": "9",
        "name": "Produkt Feed – sekret sukcesu sklepów w rękach lokalnych firm",
        "date": "19.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Dowiedz się, jak FastTony planuje przejąć najskuteczniejsze kampanie e-commerce i dostosować je do potrzeb lokalnych firm. Mówimy stop na niesprawiedliwe traktowanie lokalnych firm i dajemy technologię zarezerwowaną tylko dla sklepów każdemu lokalnemu przedsiębiorcy. Case study: salon beauty – wzrost rejestracji o 388% dzięki local feed!",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/12.png"
    },
    {
        "id": "10",
        "name": "Sztuka targetowania – jak osiągnąć najlepsze wyniki?",
        "date": "20.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Czym są zainteresowania, zachowania i grupy niestandardowe? Jak z nich korzystać, aby dotrzeć do właściwych osób? Odkryj, jak FastTony AI wykorzystuje te funkcje dla Twojej firmy.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/13.png"
    },
    {
        "id": "11",
        "name": "Jak generować leady? Głupie Pytanie: TANIO i DUŻO! Sztuką jest wiedzieć JAK to zrobić!",
        "date": "21.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Poznaj trzy skuteczne metody: AOA, AOA Lead Ads i integracja z web to learn. Dowiedz się, co robić, gdy leady stają się drogie. Poznaj metody które zwiększają zainteresowanie zakupem Twoich usług i produktów. Dowiedz się wykorzystać darmowe materiały do budowanie wiarygodnosci i wypełniania górnej części lejka sprzedażowego. I na koniec pokażemy jak technologia może podgrzewać Twoich zainteresowanych aby podsycić ogień pożądania i zapragnęli kupić od Ciebie.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/11-1.png"
    },
    {
        "id": "12",
        "name": "Reklamy z AI – proste i skuteczne - zarabiaj więcej wydając mniej!",
        "date": "22.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Dowiedz się, jak łatwo wdrożyć AI w kampanie na Facebooku, Google i Instagramie. Dlaczego ci co ograniczają się do reklam a nie robię reklam postów na Facebooku niszczą swoją sprzedaż. Naucz się, jak automatyzować marketing lokalnej firmy, łącząc telefon, Facebook, Instagram i Google Ads.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/15.png"
    },
    {
        "id": "13",
        "name": "Zbieranie leadów to dopiero początek – czas na ich 'podgrzanie'!",
        "date": "23.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Poznaj wady tradycyjnych kampanii leadowych takich jak: zapis przez landing page, zbieranie leadów przez Messenger BOT`a, oraz kampanie Lead Ads. Dowiedz się, jak AI zmieni nastawienie lead z zainteresowanego na pragnącego kupić jeszcze przed kontaktem z twojej strony, dzięki automatycznemu 'ocieplaczowi'.",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/16.png"
    },
    {
        "id": "14",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "24.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 1",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/17.png"
    },
    {
        "id": "15",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "25.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 2",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/18.png"
    },
    {
        "id": "16",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "26.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 3",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/19.png"
    },
    {
        "id": "17",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "27.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 4",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/20.png"
    },
    {
        "id": "18",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "28.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 5",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/21.png"
    },
    {
        "id": "19",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "29.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 6",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/22.png"
    },
    {
        "id": "20",
        "name": "Wyzwanie 'Twoja pierwsza reklama'",
        "date": "30.11.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Seria odcinków, która przeprowadzi Cię przez każdy krok – od stworzenia pierwszej reklamy aż do wielkiego finału w Black Friday! - Odcinek 7",
        "link": "https://www.youtube.com/@FastTonyesPolska",
        "image": "https://fasttony.com/wp-content/uploads/2024/11/23.png"
    },
    {
        "id": "21",
        "name": "GirlBosskie: Nie pracuj więcej, zarabiaj więcej. Automatyzuj zdobywanie klientów dzięki AI od FastTony",
        "date": "05.12.2024",
        "timeStart": "13:20",
        "timeEnd": "14:00",
        "description": "",
        "link": "https://girlbosskie.pl/",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/462580098_367822943055672_5161350026466168611_n.png"
    },
    {
        "id": "22",
        "name": "Jak to jest że reklamy robią się same",
        "date": "09.12.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Konsultacja dla klientów FastTony w trakcie której pokażę: - jak skonfigurować pakiet SMART - jak analizować wyniki lub zmienić ustawienia - jaką strategię promowania postów przyjąć - jakie nowe rzeczy będą dostępne już w 2025 roku. Ponadto Sesja Q&A dla wszystkich obecnych.",
        "link": "https://webinar.freshmail.pl/189-549-570",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/1.png"
    },
    {
        "id": "23",
        "name": "Jak to jest że Leady robią się same",
        "date": "10.12.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Konsultacja dla klientów FastTony w trakcie której pokażę: - jak skonfigurować pakiet FastTony BOT i FastTony Lead - jak poprawić wyniki kampanii Lead Ads - jakie są trendy w formularzach - jak zintegrować FastTony Lead z FastTony Call Me - jak płynnie zmieniać ustawienia - jakie nowe rzeczy będą dostępne już w 2025 roku. Ponadto Sesja Q&A dla wszystkich obecnych.",
        "link": "https://webinar.freshmail.pl/672-422-819",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/3.png"
    },
    {
        "id": "24",
        "name": "Jak to jest że reklamy robią się same w … Google i YouTube",
        "date": "11.12.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Konsultacja dla klientów FastTony & Forsant w trakcie której pokażę: - jak skonfigurować pakiet Forsant.IO - wytłumaczę dlaczego niezbędna jest instalacja pixela - opowiem o błędach na stronie www które niszczą wasze kampanie - jak uczyć AI aby było jeszcze lepsze - jakie nowe rzeczy będą dostępne już w 2025 roku. Ponadto Sesja Q&A dla wszystkich obecnych.",
        "link": "https://webinar.freshmail.pl/546-358-861",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/4.png"
    },
    {
        "id": "25",
        "name": "Jak to jest że reklamy robią się same na Instagramie",
        "date": "12.12.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Konsultacja dla klientów FastTony w trakcie której pokażę: - jak skonfigurować pakiet Instagram - pokażę różnice w tworzeniu reklam przez Instagram App a FastTony - opowiem o błędach na stronie www które niszczą wasze kampanie - opowiem o “trikach” w postach na Instagramie których należy unikać - opowiem jak uczyć FastTony AI aby było jeszcze lepsze - opowiem jaką przyjąć strategię aby przy małym budżecie poczuć różnicę - opowiem jakie nowe rzeczy będą dostępne już w 2025 roku. Ponadto Sesja Q&A dla wszystkich obecnych.",
        "link": "https://webinar.freshmail.pl/821-588-763",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/5.png"
    },
    {
        "id": "26",
        "name": "Jak to jest że targetowanie reklam robi się samo oraz SMS wysyłają się same",
        "date": "13.12.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Konsultacja dla klientów FastTony w trakcie której pokażę: - jak skonfigurować pakiet Call App - omówienie możliwości jakie daje Call App - przykłady użycia Call App - jak bezpłatna aplikacja pomoże każdemu lepiej targetować reklamy.",
        "link": "https://webinar.freshmail.pl/699-332-189",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/6.png"
    },
    {
        "id": "27",
        "name": "Jak To jest że posty robią się same",
        "date": "14.12.2024",
        "timeStart": "20:00",
        "timeEnd": "21:00",
        "description": "Konsultacja dla klientów FastTony w trakcie której pokażę: - jak skonfigurować pakiet POST - jak poprawić wyniki lub zmienić ustawienia - jakie nowe rzeczy będą dostępne już w 2025 roku - jak strategie Moniki Czaplickiej pomoże w Twojej Firmie. Ponadto Sesja Q&A dla wszystkich obecnych.",
        "link": "https://webinar.freshmail.pl/453-424-351",
        "image": "https://fasttony.com/wp-content/uploads/2024/12/2.png"
    },
    {
        "id": "28",
        "name": "Jak skonfigurować Smarta Krok po Kroku - oraz omówienie jego funkcji",
        "date": "14.01.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Smart. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/1.png"
    },
    {
        "id": "29",
        "name": "Call App czyli dlaczego ci co mają telefon z Androidem zarabiają szybciej",
        "date": "21.01.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Call App. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/4.png"
    },
  {
        "id": "30",
        "name": "Forsant.IO - bądź tam gdzie klient szuka konkurencji - bądź w Google! omówienie Forsant.IO",
        "date": "28.01.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Forsant.IO. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/8.png"
    },
  {
        "id": "31",
        "name": "Generowanie treści dzięki AI - omówienie Behawiorysta AI i FastTony POST",
        "date": "04.02.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Post. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/6.png",
  },
  {
        "id": "32",
        "name": "Call Me - Jak odzyskiwać ruch ze strony? Jak ruch zmienić w generowanie leadów.",
        "date": "11.02.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Call Me. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/2.png"
    },
  {
        "id": "33",
        "name": "Instagram - Zrób to dobrze dzięki targetowaniu które jest niedostępne w Instagram App",
        "date": "18.02.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Insta. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/7.png"
    },
  {
        "id": "34",
        "name": "Generowanie Leadów omówienie kampanii Lead Ads",
        "date": "25.02.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Przypomnisz sobie jak konfiguruje się aplikację FastTony Lead Ads. Omówi dla kogo ta aplikacja i jakie może przynieść korzyści w twojej Firmie. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/3.png"
    },
  {
        "id": "35",
        "name": "Korzyści z integracji pakietów. czyli 1+1=3 / Smart+Call App/ Call App + Call Me + Lead Ads / inne",
        "date": "04.03.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Dowiesz się jak uzyskać efekt synergii łącząc kilka pakietów FastTony. Omówimy jakie aplikacje mają specjalne moduły komunikacji z innymi aplikacjami i jak można to wykorzystać w Twojej firmie podnosząc skuteczność reklam. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/Kalendarz.png"
    },
  {
        "id": "36",
        "name": "Pixel facebooka? Pixel FastTony / API konwersji / Brama Konwersji - co zrobić aby dobrze to działało",
        "date": "11.03.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Co może pixel, czy potrzebujesz API konwersji a może Brama Konwersji to coś czego potrzebuje Twoja firma? Ale jak podjąc decyzje skoto te określania są dla marketingowców nie zrozumiałe a co dopiero dla normalnego przedsiębiorcy? Przyjdź i dowiedz się co szykuje nam facebook i z czym musisz się zmierzyć ale bez obaw z pomocą fastTony to będzie dziecinnie proste ",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/pixel.png"
    },
  {
        "id": "37",
        "name": "Kampanie Product feed w Ecommerce i Local Business",
        "date": "18.03.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "A gdyby tak FastTony pokazał ci jak lepiej sprzedawać w e-commerce? A gdyby tak udostępnił ci kampanie product feed? To zrobiłby wielką rzecz dla e-commerce ale nie dla lokalnych firm. A jednak. Jako pierwsza firma w polsce udostępniamy sprzedaż z katalogu produktów ale … uwaga usług! Tak! To co do tej pory dawało sklepom internetowym dużą przewagę dajemy każdemu lokalnemu przedsiębiorcy. Zobacz jakie to dobre!",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/facebook-feed-ads.png"
    },
  {
        "id": "38",
        "name": "Dogrzewanie Leadów - Jak zautomatyzować podnoszenie intencji zakupowej u klienta",
        "date": "25.03.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Rozsądni przedsiębiorcy wiedzą, że celem nie jest zdobycie leadów. Celem jest sprzedaż. Dlatego trzeba zrobić tak aby jak najwięcej leadów konwertowało. Jak. Poznaj FastTony BOT v3. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/5.png"
    },
  {
        "id": "39",
        "name": "Kampanie na Tik-Tok? Tak to proste dzięki FastTiker - omówienie postępu rozwoju aplikacji",
        "date": "08.04.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Poznaj AI do reklam na Tik Toku. Poznaj FastTiker, który budujemy dla ciebie. To nie tylko za ciebie zrobi reklamy ale i znacznie więcej ! Jak co tydzień prowadzący będzie 4 godziny odpowiadał  na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/9.png"
    },

  {
        "id": "40",
        "name": "Dlaczego 1+1=3,  1+1+1=5 lub 1+1+1+1=12! omówienie korzyści z integracji różnych app od FastTony",
        "date": "15.04.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Dowiesz się jak uzyskać efekt synergii łącząc kilka pakietów FastTony. Omówimy jakie aplikacje mają specjalne moduły komunikacji z innymi aplikacjami i jak można to wykorzystać w Twojej firmie podnosząc skuteczność reklam. Prowadzący omówi każdą zakładkę i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
    "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/Kalendarz-1.png"
    },
  {
        "id": "41",
        "name": "FastTony Smart i Forsant.IO jako fundament sprzedaży usług",
        "date": "22.04.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "Dowiesz się jak uzyskać efekt synergii łącząc FastTony z Forsant czyli świat Google i Facebooka. Dowiesz się jak przekuć intencje w zainteresowanie i zmienić nastawienie klienta a nawet światopogląd. Syneria jaką da się uzyskać dzięki połączeniu tych światów pozwoli tobie szybciej przekonywać klientów i … odebrać ich konkurencji. Prowadzący omówi temat i przeznaczy 4 godziny na odpowiadanie na pytania od uczestników.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/9.png"
    },
  {
        "id": "42",
        "name": "Jak zbudować, wytrenować i zainstalować Asystenta AI na Twojej stronie - Omówienie FastTony BOT v3",
        "date": "29.04.2025",
        "timeStart": "09:00",
        "timeEnd": "13:00",
        "description": "A gdyby tak móc zbudować Asystenta który będzie wiedział to co TY, umiał to co TY i nigdy nie próbował by wykorzystać tej wiedzy przeciwko tobie zadając coraz wyższej pensji? A gdy tak nie trzeba było płacić za niego ZUS, ani podatków? A gdyby tak twój asystent pracował by 24h na dobę i nigdy by nie miał fochów? Zawsze z radością pracował by lojalnie dla ciebie … i gdyby kosztował 5 zł dziennie? Pozna fastTony BOT v3.",
        "link": "https://akademia.fasttony.com/w/Konsultacje2025",
        "image": "https://fasttony.com/wp-content/uploads/2025/01/google-i-facebook-ads.png"
    },

]
